import { render, staticRenderFns } from "./CustomersHome.vue?vue&type=template&id=567f6f58&scoped=true"
import script from "./CustomersHome.vue?vue&type=script&lang=js"
export * from "./CustomersHome.vue?vue&type=script&lang=js"
import style0 from "./CustomersHome.vue?vue&type=style&index=0&id=567f6f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f6f58",
  null
  
)

export default component.exports